/*
 * Where the web app serves Emojibase's data from: its own origin, never a CDN, so opening the
 * picker tells no third party who is looking. `build.ts` puts the files there, from the pinned
 * `emojibase-data`, and refuses a build whose version differs from this one. The version is in the
 * path, so a new one is never answered from an old one's cache.
 */
export const emojibaseVersion = "17.0.0"

/** The base the picker reads `en/data.json` and `en/messages.json` under. */
export const emojibaseUrl = `/emojibase/${emojibaseVersion}`

/** The files the picker reads, under `emojibaseUrl`. */
export const emojibaseFiles = ["en/data.json", "en/messages.json"] as const
